import _isArray from 'lodash/isArray';
import _isDate from 'lodash/isDate';
import _isNil from 'lodash/isNil';
import _isObject from 'lodash/isObject';
import { safeJsonStringify } from '../../utils/json';

const NON_BREAKING_SPACE = ' ';

export const getStringifiedValue = (value: unknown): string =>
  !_isNil(value) ? `${value}` : NON_BREAKING_SPACE;

export const getValueByDataType = (value: unknown): string => {
  if (value && _isDate(value)) {
    return value.toString();
  }

  if (_isObject(value) || _isArray(value)) {
    return safeJsonStringify(value, '', 2);
  }

  return value as string;
};
